// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"4719d08d","591":"c6123758"}[chunkId] + ".chunk.css";
};